import { Component } from '@angular/core';
import { FacilityConfigConstants } from '../models/constants/facility-config.constants';
import { ActivatedRoute } from '@angular/router';
import {
  PanelBodyComponent,
  PanelContainerComponent,
  PanelHeaderComponent,
} from 'src/app/shared/content-panels';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  DragDropModule,
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
} from '@angular/cdk/drag-drop';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import {
  FacilityDataModel,
  FacilityStationModel,
  FacilityConfigModel,
} from '../models/facility-config.model';
import { FacilityConfigService } from '../services/facility-config.service';
import { QBuiltConstants } from '../../qbuilt/models/constants/qbuilt.constants';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { Router } from '@angular/router';
import { QBuiltService } from '../../qbuilt/services/qbuilt-service';
import { HbgSnackBar } from 'src/app/shared/toaster/hbg-toaster';
import { CanCQMSComponentDeactivate } from 'src/app/shared/guards/cqms-pending-changes.guard';

@Component({
    selector: 'app-new-edit-facility',
    imports: [
    PanelContainerComponent,
    PanelHeaderComponent,
    PanelBodyComponent,
    MatIconModule,
    MatTooltipModule,
    DragDropModule,
    CdkDrag,
    CdkDropList,
    MatExpansionModule
],
    templateUrl: './new-edit-facility.component.html',
    styleUrl: './new-edit-facility.component.scss'
})
export class NewEditFacilityComponent implements CanCQMSComponentDeactivate {
  panelHeading: string = this.facilityConfigConstants.fcPanelHeading;
  panelTitle: string = this.facilityConfigConstants.fcPanelTitle;
  addZoneBtnText: string = this.facilityConfigConstants.fcAddZoneButtonText;
  warningTooltip: string = this.facilityConfigConstants.fcWarningTooltip;
  emptyZoneText1: string = this.facilityConfigConstants.fcEmptyZoneText1;
  emptyZoneText2: string = this.facilityConfigConstants.fcEmptyZoneText2;
  emptyZoneText3: string = this.facilityConfigConstants.fcEmptyZoneText3;
  emptyStationAreaText: string =
    this.facilityConfigConstants.fcEmptyStationAreaText;
  allStationsInUse: string = this.facilityConfigConstants.fcAllStationsInUse;

  managerWalk: string = this.facilityConfigConstants.managerWalkZoneName;

  panelOpenState = true;
  allRequired: boolean = false;

  facilityNumber: string = sessionStorage.getItem('facilityNumber') || '';
  facilityDisplayData: any[] = [];
  facilityConfigId: string;

  stationList: FacilityStationModel[] = [];
  zoneList: any[] = [];
  stationListOriginal: FacilityStationModel[] = [];
  managerWalkZone: FacilityDataModel[] = [];

  saveTrigger: boolean = false;
  finalFacilityConfig: FacilityConfigModel;

  changesMade: boolean = false;

  constructor(
    private facilityConfigConstants: FacilityConfigConstants,
    private activatedRoute: ActivatedRoute,
    private facilityConfigService: FacilityConfigService,
    private qbuiltConstants: QBuiltConstants,
    private dialogService: DialogService,
    private spinnerService: SpinnerService,
    private router: Router,
    private qbuiltService: QBuiltService,
    private toaster: HbgSnackBar
  ) {
    this.facilityConfigService.facilityData$.subscribe((data) => {
      this.zoneList = data;
    });

    this.facilityConfigService.currentStationList$.subscribe((data) => {
      this.stationList = data;
    });

    this.allRequired =
      sessionStorage.getItem('allRequired') === 'true' ? true : false;
  }

  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;

  ngOnInit() {
    this.zoneList = JSON.parse(sessionStorage.getItem('facilityData') || '[]');
    this.stationList = JSON.parse(
      sessionStorage.getItem('currentPanelList') || '[]'
    );
    this.allRequired =
      sessionStorage.getItem('allRequired') === 'true' ? true : false;

    //check for edit mode
    this.activatedRoute.params.subscribe((params) => {
      this.facilityConfigId = params['id'];

      if (this.facilityConfigId) {
        //if id means its edit mode - load in data
        this.zoneList = JSON.parse(
          sessionStorage.getItem('facilityData') || '[]'
        );
        this.zoneList.sort((a, b) => a.OrderOfExecution - b.OrderOfExecution);
        this.setTempId(this.zoneList);
        this.facilityConfigService.setFacilityData(this.zoneList);
        this.stationList = JSON.parse(
          sessionStorage.getItem('currentPanelList') || '[]'
        );
        this.facilityConfigService.setCurrentStationList(this.stationList);
        sessionStorage.setItem('facilityData', JSON.stringify(this.zoneList));

        if (this.stationList.length === 0) {
          this.allRequired = true;
          this.facilityConfigService.updateAllRequired(this.allRequired);
          sessionStorage.setItem(
            'allRequired',
            JSON.stringify(this.allRequired)
          );
        } else {
          this.allRequired = false;
          this.facilityConfigService.updateAllRequired(this.allRequired);
          sessionStorage.setItem(
            'allRequired',
            JSON.stringify(this.allRequired)
          );
        }
      } else {
        if (this.zoneList.length === 0) {
          this.zoneList = [
            {
              Id: '9999',
              Name: this.managerWalk,
              Stations: [],
            },
          ];

          this.facilityConfigService.setFacilityData(this.zoneList);
          sessionStorage.setItem('facilityData', JSON.stringify(this.zoneList));
          this.populateStations();
        }
      }
    });
  }

  setTempId(zoneList: any) {
    zoneList.forEach((zone: any, index: number) => {
      zone.tempId = index + 1;
    });
  }

  //populates the station list - on first time setup
  populateStations() {
    //get stationlist from session Storage to populate
    this.qbuiltService.getInspectionConfigurationsByFacility(this.facilityNumber);
    this.qbuiltService.checklistTableData$.subscribe((data) => {
      const activeChecklist = data.find((item: any) => item.IsActive);
      const stations:any = [];
      activeChecklist.Stations.forEach((station: any) => {
        stations.push(station);
      });
      this.stationList = stations.map((station: { Id: any; Name: any; TaskGroups: any[]; Tasks: any[]; }) => ({
        Id: station.Id,
        Name: station.Name,
        InspectionTasks: station.TaskGroups.flatMap(group => group.Tasks)
      }));

      this.facilityConfigService.setCurrentStationList(this.stationList);
      sessionStorage.setItem('currentPanelList', JSON.stringify(this.stationList));

    });
  }

  //formats item count text for station UI
  formatItemCount(itemCount: number): string {
    if (itemCount === 1) {
      return itemCount + ' item';
    } else {
      return itemCount + ' items';
    }
  }

  displayTotalItemCount(stationList: any) {
    let itemCount = 0;
    if (stationList?.length > 0) {
      stationList.forEach((station: FacilityStationModel) => {
        itemCount += station.InspectionTasks.length;
      });
    }

    return itemCount > 0 ? `(${itemCount} items)` : '';
  }

  addZone() {
    this.changesMade = true;
    this.zoneList.push({
      tempId: this.zoneList.length,
      Name: 'Zone ' + this.zoneList.length,
      Stations: [],
    });
    let mwItem = this.zoneList.find((zone) => zone.Name === this.managerWalk);
    this.moveManagerWalkOrder(mwItem);
    sessionStorage.setItem('facilityData', JSON.stringify(this.zoneList));
    this.facilityConfigService.setFacilityData(this.zoneList);
  }

  //Pushes Manager Walk zone to the end of ZoneList
  moveManagerWalkOrder(mwItem: any) {
    const index = this.zoneList.indexOf(mwItem);
    if (index !== -1) {
      const [itemToMove] = this.zoneList.splice(index, 1);
      this.zoneList.push(itemToMove);
    }
  }

  deleteZone(zoneToDelete: any) {
    this.changesMade = true;
    let mwItem = this.zoneList.find((zone) => zone.Name === this.managerWalk);
    let tempList = this.zoneList.filter(
      (zone) => zone.tempId !== zoneToDelete.tempId
    );
    tempList = tempList.filter((zone) => zone.Name !== this.managerWalk);
    this.zoneList = [];
    this.zoneList = this.updateZoneOrder(tempList, mwItem);

    sessionStorage.setItem('facilityData', JSON.stringify(this.zoneList));
    this.facilityConfigService.setFacilityData(this.zoneList);
  }

  //resets the zone order after deletion of items
  updateZoneOrder(zoneList: any[], mwItem: any) {
    this.changesMade = true;
    let newList = [];
    zoneList.forEach((item) => {
      if (item.Name !== this.managerWalk) {
        newList = zoneList.map((item, index) => ({
          ...item,
          tempId: index + 1,
          Name: 'Zone ' + (index + 1),
        }));
      }
    });

    newList.push(mwItem);
    return newList;
  }

  //removes station from ZoneList by stationId
  removeStation(station: FacilityStationModel) {
    this.changesMade = true;
    this.zoneList.forEach((zone) => {
      zone.Stations.forEach((list: any) => {
        if (list.Id === station.Id) {
          const index = zone.Stations.indexOf(list);
          if (index > -1) {
            zone.Stations.splice(index, 1);
          }
        }
      });
    });
    this.stationList.push(station);
    this.stationList = this.updateStationOrder(this.stationList);
    sessionStorage.setItem('facilityData', JSON.stringify(this.zoneList));
    this.facilityConfigService.setFacilityData(this.zoneList);
    sessionStorage.setItem(
      'currentPanelList',
      JSON.stringify(this.stationList)
    );
    this.facilityConfigService.setCurrentStationList(this.stationList);
    this.allRequiredCheck(this.stationList);
  }

  updateStationOrder(stationList: FacilityStationModel[]) {
    return stationList.map((station, index) => ({
      ...station,
      OrderOfExecution: index + 1,
    }));
  }

  private syncStationPresentationOrder(): void {
    this.stationList = this.updateStationOrder(this.stationList);
    this.zoneList = this.zoneList.map((zone) => ({
      ...zone,
      Stations: this.updateStationOrder(zone.Stations || []),
    }));
  }

  private getStationIdsByPresentationOrder(zone: any): number[] {
    return (zone.Stations || [])
      .slice()
      .sort(
        (a: FacilityStationModel, b: FacilityStationModel) =>
          (a.OrderOfExecution ?? Number.MAX_SAFE_INTEGER) -
          (b.OrderOfExecution ?? Number.MAX_SAFE_INTEGER)
      )
      .map((station: FacilityStationModel) => station.Id);
  }

  drop(event: CdkDragDrop<FacilityStationModel[]>) {
    this.changesMade = true;
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    this.syncStationPresentationOrder();

    sessionStorage.setItem('facilityData', JSON.stringify(this.zoneList));
    this.facilityConfigService.setFacilityData(this.zoneList);
    sessionStorage.setItem(
      'currentPanelList',
      JSON.stringify(this.stationList)
    );
    this.facilityConfigService.setCurrentStationList(this.stationList);
    this.allRequiredCheck(this.stationList);
  }

  allRequiredCheck(stationList: FacilityStationModel[]) {
    if (stationList.length === 0) {
      this.allRequired = true;
      this.facilityConfigService.updateAllRequired(this.allRequired);
      sessionStorage.setItem('allRequired', JSON.stringify(this.allRequired));
    } else {
      this.allRequired = false;
      this.facilityConfigService.updateAllRequired(this.allRequired);
      sessionStorage.setItem('allRequired', JSON.stringify(this.allRequired));
    }
  }

  checkForEmptyZone() {
    let zonelist = JSON.parse(sessionStorage.getItem('facilityData') || '[]');
    if (zonelist && zonelist.length > 0) {
      return zonelist.some(
        (zone: { Stations: any[] }) => zone.Stations.length === 0
      );
    }
    return true;
  }

  // Implementation for CanComponentDeactivate interface
  hasUnsavedChanges(): boolean {
    return this.changesMade;
  }

  getSaveChangesDialogConfig() {
    return {
      title: this.qbuiltConstants.dialogTitle,
      message: this.qbuiltConstants.dialogMessage,
      cancelButtonText: this.qbuiltConstants.cancelButtonText,
      confirmButtonText: this.qbuiltConstants.confirmButtonText
    };
  }

  isSaveInProgress(): boolean {
    return this.saveTrigger;
  }
  
  onCancel() {
    this.router.navigate(['facility-configuration']);
  }

  onSave() {
    this.saveTrigger = true;
    this.spinnerService.show();

    if (this.facilityConfigId) {
      let facilityData = JSON.parse(
        sessionStorage.getItem('facilityData') || '[]'
      );
      this.finalFacilityConfig = {
        HBGFacilityNumber: this.facilityNumber,
        Zones: facilityData.map((zone: any, index: number) => ({
          Id: typeof zone.Id === 'number' ? zone.Id : null,
          Name: zone.Name,
          IsOverlapping: false,
          OrderOfExecution: index + 1,
          StationIds: this.getStationIdsByPresentationOrder(zone),
        })),
      };

    }else {
      let facilityData = JSON.parse(sessionStorage.getItem('facilityData') || '[]');
      this.finalFacilityConfig = {
        HBGFacilityNumber: this.facilityNumber,
        Zones: facilityData.map((zone: any, index: number) => ({
          Name: zone.Name,
          IsOverlapping: false,
          OrderOfExecution: index + 1,
          StationIds: this.getStationIdsByPresentationOrder(zone),
        })),
      };
    }
        console.log('Final Payload:', this.finalFacilityConfig);

    this.facilityConfigService
      .saveFacilityConfig(this.finalFacilityConfig)
      .subscribe({
        next: (value) => {
          if(!value.Success) {
            this.spinnerService.hide();
            this.toaster.error('Error Saving Facility Configuration!');
            console.error('Error saving facility configuration:', value.Message);
            return;
          }

          this.spinnerService.hide();
          this.router.navigate(['cqms']);
          sessionStorage.removeItem('facilityData');
          sessionStorage.removeItem('currentPanelList');
          sessionStorage.removeItem('allRequired');
          sessionStorage.removeItem('facilityNumber');
          this.router.navigate(['facility-configuration']);
        },
        error: (err) => {
          this.spinnerService.hide();
          this.toaster.open('Error Saving Facility Configuration!');
          console.error('Error saving zone:', err);
        },
      });
  }

  ngOnDestroy() {
    sessionStorage.removeItem('facilityData');
    sessionStorage.removeItem('currentPanelList');
    sessionStorage.removeItem('allRequired');
    sessionStorage.removeItem('facilityNumber');
  }
}
